"use client";

import { Cpu, Crown, TrendingUp } from "lucide-react";

export default function TechnicalSkills({ skillRef, candidates }) {
  if (!candidates || candidates.length === 0) return null;

  const getBadgeClass = (flag) => {
    return flag
      ? "text-green-800 border-green-300"
      : "text-red-800 border-red-300";
  };

  const getProgressColor = (value) => {
    if (value <= 25) return "bg-red-500";
    if (value <= 50) return "bg-orange-500";
    if (value <= 75) return "bg-yellow-500";
    return "bg-emerald-500";
  };

  return (
    <div id="skills" ref={skillRef} className="pb-10 pt-8 border-t">
      <div className="flex items-center mb-6">
        <div className="h-8 w-8 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center mr-3">
          <Cpu className="h-4 w-4" />
        </div>
        <h2 className="text-xl font-bold">Technical Skills</h2>
      </div>

      <div className="space-y-6">
        {candidates.map((candidate) => (
          <div key={candidate.id} className="space-y-6">
            {candidate.skills.map((skill) => (
              <div
                key={skill.id}
                className="border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-200 overflow-hidden grid grid-cols-[1fr,auto] mb-2"
              >
                <div className="p-6">
                  <div className="flex flex-col md:flex-row md:items-center justify-between mb-3 gap-3">
                    <h3 className="text-xl font-semibold text-gray-800">
                      {skill.name}
                    </h3>
                  </div>

                  <div className="mb-3">
                    <div className="h-3 w-full bg-gray-100 rounded-full overflow-hidden">
                      <div
                        className={`h-full rounded-full ${getProgressColor(skill.value)}`}
                        style={{
                          width: `${skill.value}%`,
                          transition: "width 1s ease-in-out",
                        }}
                      />
                    </div>
                  </div>

                  <div className="flex gap-x-2 overflow-x-auto whitespace-nowrap">
                    {skill.subSkills.map((subSkill) => (
                      <div
                        key={subSkill.id}
                        className={`inline-block px-4 py-2 rounded-lg text-sm border-l-2 truncate ${getBadgeClass(
                          subSkill.flag
                        )} transition-all duration-200 hover:shadow-sm`}
                        style={{ maxWidth: "240px" }}
                      >
                        {subSkill.name}
                      </div>
                    ))}
                  </div>
                </div>

                <div className="flex flex-col items-center justify-center p-6 gap-2 border-l bg-gray-50 w-[120px]">
                  {skill.value > 70 && (
                    <div className="text-xs px-3 py-1.5 bg-emerald-100 text-emerald-800 rounded-md font-medium whitespace-nowrap flex items-center">
                      <Crown className="w-3 h-3 mr-1" />
                      Top 1%
                    </div>
                  )}
                  <span className="text-2xl font-bold text-gray-800">
                    {skill.value}%
                  </span>
                  <div className="text-xs px-2 py-1 bg-gray-100 rounded-md text-gray-600 font-medium flex items-center w-[87px]">
                    Avg: {skill.avgValue}%
                    <TrendingUp className="w-4 h-4 text-emerald-500 ml-1" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
